module.exports = __webpack_public_path__ + "static/img/4_western_eastern_japan.68b47ceb.png";